import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div style={{ color: '#8b949e', padding: 40 }}>Загрузка...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}
